<section *ngIf="measurementCategory" class="mb-2">
    <div class="estimate-category-container">
        <a
            *ngIf="!states.isEstimateReadonly"
            class="grip-container"
            cdkDragHandle
            (mousedown)="toggleDrag(true)"
            (touchstart)="toggleDrag(true)"
            (mouseleave)="toggleDrag(false)"
            (touchend)="toggleDrag(false)">
            <span class="grip"></span>
        </a>
        <span class="order mr-2" [ngClass]="states.isEstimateReadonly ? 'ml-2' : ''">{{ measurementCategory.order }}</span>
        <div class="condensed-col description" [ngClass]="{ invalid: isInvalidCategory }">
            <input
                legacy-css
                #categoryDescription
                type="text"
                class="form-control"
                [formControl]="$any(categoryForm.controls.description)" />
            <i *ngIf="isInvalidCategory" class="fa fa-exclamation-circle"></i>
        </div>

        <app-estimate-measurement-category-actions
            [states]="states"
            [measurementCategory]="measurementCategory"
            (deleteCategoryChanges)="onDeleteCategory()"
            (toggleCategoryChanges)="onToggleCategory()">
        </app-estimate-measurement-category-actions>
    </div>

    <div *ngIf="measurementCategory.isExpanded" [@slideInTop]="slideInTopParams">
        <ng-content select=".estimate-measurement-container"></ng-content>
    </div>
</section>
